window.Parsley
  .addValidator('conditionalrequired', function (value, requirements) {
    if (requirements[1] == $(requirements[0]).val() && '' == value)
      return false;

    return true;
  }, 32);
